import { ref } from 'vue';

export function useRecaptcha(siteKey) {
  const isRecaptchaLoaded = ref(false);

  function loadRecaptcha() {
    return new Promise((resolve, reject) => {
      if (window.grecaptcha) {
        isRecaptchaLoaded.value = true;
        resolve(window.grecaptcha);
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (window.grecaptcha) {
          isRecaptchaLoaded.value = true;
          resolve(window.grecaptcha);
        } else {
          reject(new Error('grecaptcha non disponible après chargement du script'));
        }
      };
      script.onerror = () => reject(new Error('Erreur lors du chargement de reCAPTCHA'));
      document.head.appendChild(script);
    });
  }

  function executeRecaptcha(action) {
    return new Promise((resolve, reject) => {
      if (!isRecaptchaLoaded.value) {
        reject(new Error("reCAPTCHA n'est pas chargé."));
        return;
      }

      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  }

  return {
    loadRecaptcha,
    executeRecaptcha,
  };
}
